export default "__VITE_ASSET__D_OqmF4J__"